import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";

export const IdaasContentDefind = () => {
  const { t } = useTranslation();
  return (
    <div className="idaas-defind" id="idaas_explaination">
      <div className="overview">
        <p>{t("solution.idaas.explaination.overview1")}</p>
        <p>{t("solution.idaas.explaination.overview2")}</p>
      </div>
      <div className="explaination">
        <div className="explain-block idaas">
          <div className="title">{t("solution.idaas.explaination.idaasDefine.title")}</div>
          <div className="descript">{t("solution.idaas.explaination.idaasDefine.subtitle")}</div>
          <div className="descript-item">{t("solution.idaas.explaination.idaasDefine.item1")}</div>
          <div className="descript-item">{t("solution.idaas.explaination.idaasDefine.item2")}</div>
          <div className="descript-item">{t("solution.idaas.explaination.idaasDefine.item3")}</div>
          <div className="descript-item">{t("solution.idaas.explaination.idaasDefine.item4")}</div>
          <div className="descript-item">... ...</div>
        </div>
        <div className="explain-block iam">
          <div className="title">{t("solution.idaas.explaination.iamDefine.title")}</div>
          <div className="descript">{t("solution.idaas.explaination.iamDefine.subtitle1")}</div>
          <div className="descript-img">
            <img src={"//files.authing.co/authing-website/idass-defind-img.png"} alt="authing idaas defind" />
          </div>
          <div className="descript-img-text">{t("solution.idaas.explaination.iamDefine.imgText")}</div>
          <div className="descript">{t("solution.idaas.explaination.iamDefine.subtitle2")}</div>
        </div>
      </div>
    </div>
  );
};
